import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../../services/application.service';
import {EnumerationService} from '../../../services/enumeration.service';

@Component({
  selector: 'app-modal-absence-picker',
  templateUrl: './modal-absence-picker.component.html',
})
export class ModalAbsencePickerComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  userType: number | any;
  dataInit = true;
  dataModel: {
    index: number | undefined,
    from: string | Date | undefined,
    to: string | Date | undefined,
    noDispoFrom: string | Date | undefined,
    noDispoTo: string | Date | undefined,
    deputy: string
  } = {
    index: undefined,
    from: undefined,
    to: undefined,
    noDispoFrom: undefined,
    noDispoTo: undefined,
    deputy: ''
  };
  dataModelClone: any;
  hintText = 'Keine Vergangenen Werte!';
  today = new Date(Date.now());

  constructor(public popUpService: ExgModalService,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    if (this.data) {
      delete this.data.until;
      this.dataModel = this.appSvc.helperObj.clone(this.data);
      this.dataModel.from = new Date(this.dataModel.from as string);
      this.dataModel.to = new Date(this.dataModel.to as string);
      this.dataModel.noDispoFrom = new Date(this.dataModel.noDispoFrom as string);
      this.dataModel.noDispoTo = new Date(this.dataModel.noDispoTo as string);
      this.dataInit = false;
    }
    this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
  }

  dateValid(date: any): boolean {
    if (date) {
      if (this.userType === 1) {
        return false;
      }
      if (this.userType === 2) {
        return new Date(date) < this.today;
      }
    }
    return false;
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.popUpService.close();
  }

  save(): void {
    if (this.canSave()) {
      this.dataModelClone.from = new Date(this.dataModelClone.from).toJSON();
      this.dataModelClone.to = new Date(this.dataModelClone.to).toJSON();
      this.dataModelClone.noDispoFrom = new Date(this.dataModelClone.noDispoFrom).toJSON();
      this.dataModelClone.noDispoTo = new Date(this.dataModelClone.noDispoTo).toJSON();
      this.popUpService.action(this.dataModelClone);
    }
  }

  canSave(): boolean {
    const rt = this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone);
    const rt1 = !!(this.dataModelClone.from && this.dataModelClone.to && this.dataModelClone.noDispoTo && this.dataModelClone.noDispoFrom);
    const rt2 = !(
      this.dateValid(this.dataModelClone.from) ||
      this.dateValid(this.dataModelClone.to) ||
      this.dateValid(this.dataModelClone.noDispoFrom) ||
      this.dateValid(this.dataModelClone.noDispoTo)
    );

    return rt && rt1 && rt2;
  }
}
